import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IDac6ReporterState } from '../../store/reducers/dac6-reporter.reducer';
import { Store } from '@ngrx/store';

import { Dac6CellDecoratorComponent } from '../dac6-cell-decorator/dac6-cell-decorator.component';
import { ParticleService } from '@core/services/particle.service';

@Component({
    standalone: false,
    selector: 'lib-dac6-reporter-content',
  templateUrl: './dac6-reporter-content.component.html',
  styleUrls: ['./dac6-reporter-content.component.scss']
})
export class Dac6ReporterContentComponent implements OnInit, OnDestroy {
  currentMenu: string;
  constructor(private store: Store<IDac6ReporterState>,
              private router: Router,
              private particleService: ParticleService,
              private activatedRoute: ActivatedRoute) {
    particleService.registerCellComponent('Dac6CellDecorator', Dac6CellDecoratorComponent);
  }


  ngOnInit () {
    const url = this.router.url.split('/');
    this.currentMenu = url[url.length - 1];
  }
  ngOnDestroy() {
    // this.ngUnsubscribe.next();
    // this.ngUnsubscribe.complete();
  }
}
